'use client'

/**
 * Unsaved Changes Hook (Issue #4262)
 *
 * Shows browser-native confirmation dialog when the user
 * tries to navigate away or close the tab with unsaved
 * changes. Prevents accidental data loss.
 */

import { useEffect } from 'react'

/**
 * Register a beforeunload handler that warns the user
 * when they have unsaved changes.
 *
 * @param hasUnsavedChanges - Whether the form has unsaved
 *   changes that would be lost on navigation.
 *
 * @example
 * useUnsavedChanges(formData !== initialData)
 */
export function useUnsavedChanges(hasUnsavedChanges: boolean): void {
  useEffect(() => {
    if (!hasUnsavedChanges) return

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault()
    }

    window.addEventListener('beforeunload', handler)
    return () => {
      window.removeEventListener('beforeunload', handler)
    }
  }, [hasUnsavedChanges])
}
